export default __webpack_public_path__ + "static/media/shows.8b9b4959.svg";